import { ACTION_TYPES } from 'lib/Constants'

const {
    LOAD_EVENT_PAGE_NUMBER_REQUEST,

    CLEAR_EVENT_NOTE_COMPOSED_LIST,
    CLEAR_EVENT_NOTE_COMPOSED_LIST_ERROR,

    CLEAR_EVENT_NOTE_COMPOSED_LIST_FILTER,
    CHANGE_EVENT_NOTE_COMPOSED_LIST_FILTER,
    CHANGE_EVENT_NOTE_COMPOSED_LIST_FILTER_FIELD,

    LOAD_EVENT_NOTE_COMPOSED_LIST_REQUEST,
    LOAD_EVENT_NOTE_COMPOSED_LIST_SUCCESS,
    LOAD_EVENT_NOTE_COMPOSED_LIST_FAILURE
} = ACTION_TYPES

export default {
    LOAD_EVENT_PAGE_NUMBER_REQUEST,

    CLEAR: CLEAR_EVENT_NOTE_COMPOSED_LIST,
    CLEAR_ERROR: CLEAR_EVENT_NOTE_COMPOSED_LIST_ERROR,
    CLEAR_FILTER: CLEAR_EVENT_NOTE_COMPOSED_LIST_FILTER,
    CHANGE_FILTER: CHANGE_EVENT_NOTE_COMPOSED_LIST_FILTER,
    CHANGE_FILTER_FIELD: CHANGE_EVENT_NOTE_COMPOSED_LIST_FILTER_FIELD,
    LOAD_REQUEST: LOAD_EVENT_NOTE_COMPOSED_LIST_REQUEST,
    LOAD_SUCCESS: LOAD_EVENT_NOTE_COMPOSED_LIST_SUCCESS,
    LOAD_FAILURE: LOAD_EVENT_NOTE_COMPOSED_LIST_FAILURE
}